<template>
<div>
  <div class="row">
    <div class="col-md-12 animate-box">
        <div class="archives head-site">
            <h1 v-if="this.lang=='fr-CA'">Services disponibles</h1>										
            <h1 v-else>Advantage Provider Locator</h1>
        </div>
    </div>
  </div>
  <div class="col-md-12" v-if="this.loadImg==true">
        <img  :src="LOCAL_HOST+'/ThemeMegazine/images/loader_dot.gif'" height="20" />
  </div>
  <div class="row" v-if="main_content!='' && this.loadFirst && provider_content!=''">
    <div class="col-md-12 animate-box">
        <div id="mapTD" class="archives ">	
            <div v-if="provider_content != ''"> 
                <TravelMap class="travel-map" :markers='provider_content' />
            </div>
            <span id="lbNote" v-if="this.lang=='fr-CA'">(*) Les 5 premiers fournisseurs sont affichés.</span>
            <span id="lbNote" v-else>(*) First 5 providers are shown.</span>	
        </div>
    </div>
  </div>

  <div class="row">
    <div class="col-md-12 animate-box">
        <div class="archives tbl-outer" v-if="main_content!='' && this.loadFirst">
		<table class="tablelist" cellspacing="0" cellpadding="4" rules="all" border="1" id="providersGrid">
            <tr v-if="this.lang=='fr-CA'">
                <th scope="col">Nº</th>
                <th scope="col">Type</th>
                <th scope="col">Nom</th>
                <th scope="col">Adresse</th>
                <th scope="col">Ville</th>
                <th scope="col" v-if="main_content[0]['Country']=='UK'">Autorité locale</th>
                <th scope="col" v-else-if="main_content[0]['Country']=='CA'">Province</th>
                <th scope="col" v-else>État</th>
                <th scope="col">Code postal</th>
                <th scope="col">Comté</th>
                <th scope="col">Téléphone</th>
                <th scope="col">Adresse URL</th>
                <th scope="col">Courriel</th>
                <th scope="col">Carte</th>
            </tr>
            <tr v-else>
                <th scope="col">No</th>
                <th scope="col">SubType</th>
                <th scope="col">Name</th>
                <th scope="col">Address</th>
                <th scope="col">City</th>
                <th scope="col" v-if="main_content[0]['Country']=='UK'">Local Authority</th>
                <th scope="col" v-else-if="main_content[0]['Country']=='CA'">Province</th>
                <th scope="col" v-else>State</th>
                <th scope="col">PostCode</th>
                <th scope="col">County</th>
                <th scope="col">PhoneNumber</th>
                <th scope="col">Url</th>
                <th scope="col">Email</th>
                <th scope="col">Map</th>
            </tr>
            <tr v-for="(s,i) in main_content" :key="i">
                <td>{{ ++i }}</td>  
                <td>{{ s.PvdSubType }}</td> 
                <td>{{ s.Name }}</td>  
                <td>{{ s.Address }}</td>
                <td>{{ s.City }}</td>
                <td>{{ s.State }}</td>
                <td>{{ s.Zip }}</td>
                <td>{{ s.County }}</td>
                <td>{{ s.Phone }}</td>
                <td>{{ s.Url }}</td>
                <td>{{ s.EmailAddress }}</td>
                <td><a v-if="s.Latitude!=0" v-bind:href="'/providerLocatorMap/?gLa='+s.Latitude+'&gLo='+s.Longitude+'&gCi='+s.Name+';'+s.Address+';'+s.City+';'+s.State+';'+s.Country+';'+s.Zip+';'+s.Phone+'&lang='+lang"  onclick="return callWindow(this.href)">Map</a></td>
            </tr>
        </table>
        </div>
        <div class="col-md-12" v-if="this.loadImg==true && this.page != '1'">
            <img  :src="LOCAL_HOST+'/ThemeMegazine/images/loader_dot.gif'" height="20" />
        </div>
        <div class="archives tbl-outer" v-if="main_content=='' && this.loadFirst == false" > No data found!</div>
	</div>
  </div>

  <div class="row" id='showLoadMore'>
      <div class="col-md-12 animate-box">
          <p v-if="this.lang=='fr-CA'"><a href="" class="mouseover " @click.prevent="loadMorePage()">Charger plus de résultats</a></p>
          <p v-else><a href="" class="mouseover " @click.prevent="loadMorePage()">Load More Results</a></p>
      </div>    
  </div>    
					
<div class="row" id='showFooter'>
    <div class="col-md-12 animate-box">
        <div class="archives footer-arch">	
            <div id="footer">
                <p v-if="this.lang=='fr-CA'" class="copyright-text">
                    Droit d'auteur &copy; <span v-html="dateYear"></span> - Workplace Options
                </p>
                <p v-else class="copyright-text">
                    Copyright &copy; <span v-html="dateYear"></span> - Workplace Options
                </p>
            </div>
            <p class="MsoNormal disclaimer-footer" >
                <span id="Label1" v-if="this.lang=='fr-CA'">Clause de non-responsabilité:
                    Vous avez le droit et la responsabilité d’évaluer et de choisir la solution la plus appropriée.
                    prestataire de soins pour votre personne à charge. Les références ne sont pas des approbations ou des recommandations
                    des programmes ou des prestataires, et ils n'ont pas non plus été sélectionnés, interviewés et/ou
                    approuvé par votre service ressource et référence ou votre employeur. La responsabilité
                    le choix et l'emploi d'un prestataire vous incombent entièrement. Il est fortement recommandé
                    que vous vérifiez les informations auprès du fournisseur, de l'établissement ou de l'agence référé.
                </span>	
                <span id="Label1" v-else>Disclaimer:
                    You have the right and responsibility to evaluate and choose the most appropriate
                    care provider for your dependent. Referrals are not endorsements or recommendations
                    of the programs or the providers, nor have they been screened, interviewed and /or
                    approved by your resource and referral service or your employer. The responsibility
                    for selecting and employing a provider lies fully with you. It is strongly recommended
                    that you verify information with the referred provider, facility or agency.
                </span>											
            </p>
        </div>
    </div>
</div>
</div>
</template>

<script>
import axios from 'axios';
import TravelMap from "./TravelMap";

export default {
    name: 'mainContent',
    data(){
        return{
            main_content:[],
            CONTENT_DOMAIN:this.$store.state.CONTENT_DOMAIN,
            LOCAL_HOST:this.$store.state.LOCAL_HOST,
            content_ready:false, provider_content:[],
            loadFirst: true,
            loadMore: true,
            loadImg : true,
            page: 1,
            pageSize: 10,
            dateYear:'',
            lang:''
        };        
    },
    components: {
        TravelMap
    },
    beforeMount :function() {
        this.showContent();
        this.setLang();
    },
    mounted :function(){
        this.handleScroll();
        this.setDateIn();
       //console.log(this.main_content)
	},
    methods:{
        setLang(){
            if(this.$route.query.lang=='fr-CA'){
                this.lang = 'fr-CA';
            } else {
                this.lang = 'en';
            }             
        },
        setDateIn(){
			var currentDate = new Date()
        	this.dateYear=currentDate.getUTCFullYear()
		},
      showContent(){
          var api_private_key=this.get_api_key_mix('gels')
          axios.get(this.$store.state.apiUrl+'/get_provider_locator_details',{
              params:{
                  pR:this.$route.query.pR,
                  pT:this.$route.query.pT,
                  pE:this.$route.query.pE,
                  pC:this.$route.query.pC,
                  pZ:this.$route.query.pZ,
                  pA:this.$route.query.pA,
                  pS:this.$route.query.pS,
                  pCnt:this.$route.query.pCnt,
                  pCt:this.$route.query.pCt,
                  pRt:this.$route.query.pRt,
                  pG:this.$route.query.pG,                 
                  privatekey:api_private_key,
                  id_company:this.$store.state.companyData['id_company'],
                  pageNumber:this.page,
                  pageCount:this.pageSize,
                  id_session:this.$store.state.companyData['id_session']                
              }
          })
          .then(response => {              
                response = response.data;
                //console.log(response);
                this.main_content = response.data;
                var providerContent = {};
                var i;var sid=0;
                var aryLength = this.main_content.length;
                if(aryLength >= 5){
                    aryLength = 5;
                }
                for(i=0;i<aryLength;i++){ 
                    var tmp = {};
                    var tmp1 = {};
                    if(this.main_content[i]['Latitude']!=0){                     
                        tmp['title'] = this.main_content[i]['Name']; 
                        tmp1['lat'] = parseFloat(this.main_content[i]['Latitude']); 
                        tmp1['lng'] = parseFloat(this.main_content[i]['Longitude']); 
                        tmp['position'] = tmp1;
                        providerContent[sid++] = tmp;  
                    }              
                }
                if(!Object.keys(providerContent).length){
                    providerContent = '';
                }  
                //console.log(providerContent);
                this.provider_content = providerContent;
                document.getElementById('showLoadMore').style.display = 'block';    
                //content_ready=true;    
                if(response.totalCount == '0' || response.totalCount == ''){
                    this.loadFirst = false;
                    this.main_content = '';
                    //document.getElementById('showFooter').style.display = 'block';
                    document.getElementById('showLoadMore').style.display = 'none';
                }
                this.loadImg = false;      
          })
          .catch(() => {
                this.main_content = []
          });
      },
        handleScroll(){
            window.onscroll = () => {
                let bottomOfWindow = document.documentElement.scrollTop + window.innerHeight === document.documentElement.offsetHeight;

                if (bottomOfWindow && this.loadMore) {
                    this.loadImg = true;
                    var api_private_key=this.get_api_key_mix('gels')
                    axios.get(this.$store.state.apiUrl+'/get_provider_locator_details',{
                        params:{
                            pR:this.$route.query.pR,
                            pT:this.$route.query.pT,
                            pE:this.$route.query.pE,
                            pC:this.$route.query.pC,
                            pZ:this.$route.query.pZ,
                            pA:this.$route.query.pA,
                            pS:this.$route.query.pS,
                            pCnt:this.$route.query.pCnt,
                            pCt:this.$route.query.pCt,
                            pRt:this.$route.query.pRt,
                            pG:this.$route.query.pG,                 
                            privatekey:api_private_key,
                            id_company:this.$store.state.companyData['id_company'],
                            pageNumber:++this.page,
                            pageCount:this.pageSize,
                            id_session:this.$store.state.companyData['id_session']                
                        }
                    })
                    .then(response => {               
                            response = response.data;
                            if(response.data.length > '0'){
                                this.main_content = this.main_content.concat(response.data);
                                document.getElementById('showLoadMore').style.display = 'block';   
                                /*for(var i=0;i<response.length;i++){
                                    this.main_content.push(response[i]);
                                }*/
                            } else {
                                this.loadMore = false;
                                //document.getElementById('showFooter').style.display = 'block';
                                document.getElementById('showLoadMore').style.display = 'none';
                            }  
                           //console.log(this.main_content);
                           this.loadImg = false;                          
                    });
                }
            };
        },
        loadMorePage(){
            this.loadImg = true;
            document.getElementById('showLoadMore').style.display = 'none';
            var api_private_key=this.get_api_key_mix('gels')
            axios.get(this.$store.state.apiUrl+'/get_provider_locator_details',{
                params:{
                    pR:this.$route.query.pR,
                    pT:this.$route.query.pT,
                    pE:this.$route.query.pE,
                    pC:this.$route.query.pC,
                    pZ:this.$route.query.pZ,
                    pA:this.$route.query.pA,
                    pS:this.$route.query.pS,
                    pCnt:this.$route.query.pCnt,
                    pCt:this.$route.query.pCt,
                    pRt:this.$route.query.pRt,
                    pG:this.$route.query.pG,                 
                    privatekey:api_private_key,
                    id_company:this.$store.state.companyData['id_company'],
                    pageNumber:++this.page,
                    pageCount:this.pageSize,
                    id_session:this.$store.state.companyData['id_session']                
                }
            })
            .then(response => {               
                    response = response.data;
                    if(response.data.length > '0'){
                        this.main_content = this.main_content.concat(response.data);
                        document.getElementById('showLoadMore').style.display = 'block';   
                        /*for(var i=0;i<response.length;i++){
                            this.main_content.push(response[i]);
                        }*/
                    } else {
                        this.loadMore = false;
                        //document.getElementById('showFooter').style.display = 'block';
                        document.getElementById('showLoadMore').style.display = 'none';
                    }  
                    //console.log(this.main_content);
                    this.loadImg = false;                          
            });
        }
    }
};
</script>
<style scoped>
.head-site{
    text-align: center;
    padding: 2em 2em 0.8em 2em;
}
.tablelist{
    border-color: #dcdcdca8;
    color:#333333;
    width:100%;
    border-collapse:collapse;
}
.tablelist td, th {
    padding: 10px 5px 10px 5px;
    font-size: 12px;
}
.tablelist tr th{
    background-color: #888888;
    color:White;
    /* background-color:#5D7B9D; */
    font-weight:bold;
}
.tbl-outer{
    overflow: auto;
    padding: 10px;
}
.disclaimer-footer{
    text-align: justify;
    font-size: 13px;
}
.copyright-text{
    text-align: center;
}
.footer-arch{
    padding: 1em 2em 0.8em 2em !important;
}
.travel-map {
  width: 100%;
  height: 400px;
}
#showFooter{
    /*display: none;*/
}
#showLoadMore{
    display: none;
}
.mouseover{
    cursor: pointer;
    float:right;
}
</style>